module.exports = __webpack_public_path__ + "static/media/html5-logo.476d3632.webp";